// Version : 0.0.1
// Author : NANDHA
// LastEdit : KARTHEESWARAN
// MODFIED DATE:25-09-2025
// LAST ADD : CHANGE THE SERVICE NAME FROM CAPS TO SMALL

import { makeApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';

/************** GET BRANCH REPORT LIST START ************** */
export const branchCollectionReportListGet = (listData: any) => {
	const data = {
		GetBranchCollectionReportToken: listData,
	};
	const url = `${API_URL}getBranchCollectionDetails`;
	return makeApiCall(url, data);
};
/************** GET BRANCH REPORT LIST END ************** */
